// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2s6lg","title":"Info_title__3QWu8","links":"Info_links__2x9hO","link":"Info_link__g-Aow","logo":"Info_logo__3_HEW"};